import { twJoin } from 'tailwind-merge';

import { DotsHorizontalIcon } from '@/core/tamagoshiTailwind/icons/DotsHorizontalIcon';

type EllipsisItemProps = {
  showOnlyInMobile?: boolean;
};

export function EllipsisItem({ showOnlyInMobile }: EllipsisItemProps) {
  return (
    <li
      className={twJoin(
        `flex size-xl select-none items-end justify-center
        text-foundation-disabled`,
        showOnlyInMobile && 'tablet:hidden',
      )}
      role="presentation"
    >
      <DotsHorizontalIcon className="h-[20px] w-[22px]" />
    </li>
  );
}
